import { useEffect } from "react"

import {
  useForm,
  usePayloadFormatters,
  useStepTransition
} from "@garantidos/hooks"

import isMobile from "@mobi/utils/browser/isMobile"

import validatorsDictionary from "pages/Proposal/hooks/validators"

import { ProposalContext, useProposalContext } from "contexts/proposal"

import * as trackers from "../../trackings"
import { fields } from "./fields"

export function useSimulationForm({ setIsSimulationSubmitting }) {
  const { form } = useForm({
    fields,
    context: ProposalContext,
    validatorsDictionary
  })

  const { setValue, getValues } = form

  const {
    cpfData,
    sendProposalData,
    fetchProposalData,
    errorMessage,
    setErrorMessage,
    isLoading,
    errorHandler,
    proposalData,
    stepInfo,
    setIsStepVisible
  } = useProposalContext()

  const { stepNavigator } = useStepTransition(setIsStepVisible)

  const { previousStep } = stepInfo

  const { simulation_results: simulationOffers } = proposalData

  const { hashedCpf } = cpfData

  const { formatSendPayload } = usePayloadFormatters(fields)

  const onSubmitCallback = async (formData) => {
    try {
      setIsSimulationSubmitting(true)

      const payload = formatSendPayload(formData)
      await sendProposalData({ payload })
      trackers.doSimulation(hashedCpf)

      setIsSimulationSubmitting(false)
    } catch (error) {
      setIsSimulationSubmitting(false)
      trackers.alert(hashedCpf, error)
      errorHandler(error)
    }
  }

  const handlePrevStep = async () => {
    if (isLoading) return
    try {
      await fetchProposalData({ step: previousStep, recaptcha: true })
      trackers.back(hashedCpf)

      const navigatorPreviousStep = isMobile
        ? "softlead-simulation-phone"
        : previousStep
      stepNavigator("prev", navigatorPreviousStep)
    } catch (error) {
      trackers.alert(hashedCpf, error)
      errorHandler(error)
    }
  }

  useEffect(() => {
    const financingTerm = getValues("financing_term")
    if (!simulationOffers && !financingTerm) {
      setValue("financing_term", "20", { shouldValidate: true })
    }
  }, [simulationOffers])

  useEffect(() => {
    if (simulationOffers) {
      trackers.resultsLoaded()
    }
  }, [simulationOffers])

  return {
    onSubmitCallback,
    fields,
    form,
    errorMessage,
    setErrorMessage,
    isLoading,
    handlePrevStep
  }
}
